export const FEATURE_FLAGS = {
    enableMultipleLanguages: false,
    enableIntroPage: false,
    enableHomePageTeamsSection: false,
    enableHomePageLatestActivitiesSection: false,
    enableFiltersOnScoreboard: false,
};